
const colors = {
    peach: '#fedcd2',
    orange: '#df744a',
    lightBlue: '#8eaebd',
    powder: '#bfd8d2',
    lemon: '#dcb239',
    gunmetal: '#223843',
    cultured: '#eff1f3',
    lightGray: '#dbd3d8',
    desertSand: '#d8b4a0',
    terracotta: '#d77a61',
    independence: '#4f5d75',
    lighterBlue: '#a9c8cf',
    columbiaBlue: '#cdebf3'
}

const expList = [
    {
        title: 'Jobs',
        items: [
            {
                title: 'Professional Representative',
                business: 'Gonzaga Career and Professional Development Center',
                date: 'January 2022 - present',
                location: 'Seattle, WA',
                link: 'https://www.gonzaga.edu/student-life/career-services',
                descriptions: [
                    "Acts as a career mentor to peers through the job recruitment process",
                    "Provides advice for crafting effective resumes and cover letters as well as strategies for succeeding in interviews"
                ]
            }
        ]
    },
    {
        title: 'Internships',
        items: [
            {
                title: 'Human Resources Intern - Compensation and Benefits',
                business: 'Grange Insurance Association',
                date: 'Summer 2022',
                location: 'Seattle, Wa',
                link: 'https://www.grange.com/',
                descriptions: [
                    'Updated compensation structure, salaries, job matching, and reporting in PayFactors compensation system as a part of compensation restructuring project to	ensure competitive salaries within the market',
                    'Revised PTO policy, drafted remote	work policy, and updated over 150 job descriptions',
                    'Participated in “invest in	employees” strategic corporate planning	taskforce designed to evaluate the state of	employee satisfaction and wellbeing	to understand how to better	retain and attract talent',
                    'Designed employee satisfaction surveys covering a variety of topics ranging from 6-month workplace satisfaction to company-wide benefits satisfaction',
                    'Standardized job description forms and formatting and updated over 150 job descriptions to more accurately reflect the work and responsibilities of employees',
                    'Created a visual organizational hierarchy that allowed managers to better understand what positions reported to who'
                ]
            },
            {
                title: 'Business Office Intern',
                business: 'Olson Kundig Architects',
                date: 'July 2017',
                location: 'Seattle, WA',
                link: 'https://olsonkundig.com/',
                descriptions: [
                    "Organized and filed financial records",
                    "Dead filed old financial records"
                ]
            },
            {
                title: 'Interiors Intern',
                business: 'Olson Kundig Architects',
                date: 'July 2016',
                link: 'https://olsonkundig.com/',
                descriptions: [
                    "Organized resources including fabrics, flooring and paint samples",
                    "Assisted in creating project Sample Board for clients"
                ]
            }
        ]
    },
    {
        title: 'Non-Profits',
        items: [
            {
                title: 'Volunteer',
                business: 'Boys and Girls Club of Spokane',
                date: 'January 2022 - May 2022',
                location: 'Northtown Club, Spokane, WA',
                link: 'https://www.bgcspokane.org/northtown',
                descriptions: [
                    'Provided homework help, educational activities, engaging physical activity, and emotional support to students in need of after-school care for two hours every week'
                ]
            },
            {
                title: 'Volunteer',
                business: 'Vanessa Behan',
                date: 'January 2022 - May 2022',
                location: 'Spokane, Wa',
                link: 'https://www.vanessabehan.org/',
                descriptions: [
                    'Provided business consulting services to Vanessa Behan an organization dedicated to ending child abuse by providing accessible resources to parents in Spokane Washington',
                    'Created donor profiles through demographic research and conducted SEO analysis to provide tangible ways for Vanessa Behan to attract new donors',
                ]
            },
            {
                title: 'Volunteer',
                business: 'Transitions Educare',
                date: 'August 2021',
                location: 'Spokane, WA',
                link: 'https://serve.gonzaga.edu/agency/detail/?agency_id=39577',
                descriptions: [
                    "Build meaningful relationships with children",
                    "Provide engaging learning and play activities"
                ]
            },
            {
                title: 'Volunteer',
                business: 'ZoNE',
                date: 'July 2016',
                location: 'Spokane, WA',
                link: 'https://thezonespokane.org/',
                descriptions: [
                    "Prepared two-hour informational session about money management and job search advice in collaboration with 4 other students",
                    "Presented to and assisted at-risk women re-entering the workforce"
                ]
            }
        ]
    },
    {
        title: 'Clubs',
        items: [
            {
                title: 'Member',
                business: 'New Venture Lab',
                date: 'September 2021 - May 2022',
                location: 'Spokane, WA',
                link: 'https://www.gonzaga.edu/school-of-business-administration/hogan-leadership-program/new-venture-lab',
                descriptions: [
                    "A club that provides free business consulting to local entrepreneurs and business owners",
                    "Worked collaboratively with an eight-member team to address organizational concerns with a local budding nonprofit and provided a detailed marketing plan to help raise interest and support within the local community",
                    "Participated in three presentations that communicated our consulting advice to a panel of board members",
                ]
            },
            {
                title: 'Recruitment Chair',
                business: 'Gonzaga Women in Business',
                date: 'November 2020 - May 2022',
                location: 'Spokane, WA',
                link: 'https://gonzaga.campuslabs.com/engage/organization/gwib',
                descriptions: [
                    "A club dedicated to empowering women in the workforce by providing members with resources and knowledge to help them succeed in future careers through guest speakers, workshops, and mentorship",
                    "Led a successful recruitment process through effective coordination of club fairs, and info sessions",
                ]
            },
            {
                title: 'Selections Chair',
                business: 'Setons of Gonzaga',
                date: 'April 2020 - May 2022',
                location: 'Spokane, WA',
                link: 'https://gonzaga.campuslabs.com/engage/organization/SETONS',
                descriptions: [
                    "A club dedicated to service, leadership, and relationship building. Has served at over 20 local nonprofits in the Spokane community",
                    "Led a three-month-long recruitment process to select 30 new club members",
                    "Fostered a positive environment during recruitment events and facilitated activities and events for 60+ people"
                ]
            },
        ]
    }
]

export { colors, expList }